import { createStore } from '@stencil/store';

import { INews } from '../models/typing';

// eslint-disable-next-line @stencil-community/ban-exported-const-enums
export enum TabsType {
  Recent = 'Recent',
  Events = 'Events',
}

export interface INewsStore {
  tab: TabsType;
  recent: INews[];
  unseenNewsCount: number;
  currentEventCount: number;
  page: number;
  pages: number;
}

const { state } = createStore<INewsStore>({
  tab: TabsType.Recent,
  recent: null,
  unseenNewsCount: 0,
  currentEventCount: 0,
  page: 1,
  pages: null,
});

export default state;
